module.exports = __webpack_public_path__ + "static/media/iconEditBorder.91005f5b.svg";